import { useMutation } from '@tanstack/react-query';
import { cloneDashboard } from '@src/api/dashboards';

function useCloneDashboardMeta() {
  const cloneMutation = useMutation(cloneDashboard);

  return { cloneMutation };
}

export default useCloneDashboardMeta;
